import { useMutation, useQueryClient } from 'react-query';
import { getLibraryMymesAPI } from '@myme/api';
import { removeMymeFromLibrary } from '@myme/logic';
import { UUID } from '@myme/utils';
import { useTranslation } from 'src/hooks';
import { toast, ToastType } from 'src/utils';

export const useRemoveMymeFromLibrary = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const removeMymeFromLibraryMutation = useMutation(async (mymeId: UUID) => removeMymeFromLibrary(mymeId), {
    onSuccess: () => {
      toast(ToastType.SUCCESS, t('pages.library.remove_from_library_toast_success'));
      queryClient.refetchQueries(getLibraryMymesAPI.cacheKeys);
    }
  });

  return removeMymeFromLibraryMutation;
};
